module.exports = __webpack_public_path__ + "static/img/4825_phase_function_Paper_Points.8a93ea0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4825_phase_function_Paper_Points.png
// module id = dqcK
// module chunks = 0